<form 
    [formGroup]="form" 
    (submit)="onSubmit()" 
    class="grid col3 xsCol1 gaps"
>

  <kendo-formfield class="mbs" *ngIf="!timeEntryisRunning">
    <kendo-label text="Tätigkeit"></kendo-label>
    <kendo-dropdownlist
      [data]="timeEntryCategories"
      textField="name"
      valueField="id"
      [valuePrimitive]="false"
      formControlName="timeEntryCategory"
      [defaultItem]="defaultItem"
    >
    </kendo-dropdownlist>
    <kendo-formhint>
      Wählen Sie Ihre Tätigkeit
    </kendo-formhint>
  </kendo-formfield>

  <ng-container *permissionIf="'Permissions.Assignments.Search'">
    <kendo-formfield class="mbs" *ngIf="!timeEntryisRunning && !assignment">
      <kendo-label text="Auftrag"></kendo-label>
      <app-assignment-combobox
        formControlName="assignment"
        [valuePrimitive]="false"
        [hideClosedAssigments]="true"
      ></app-assignment-combobox>
      <kendo-formhint>
        Suchen Sie nach einem Auftrag
      </kendo-formhint>
    </kendo-formfield>
  </ng-container>

      
  <div class="mbs">
    <label></label>
    <button
      type="submit"
      kendoButton
      fillMode="solid"
      size="large"
      rounded="large"
      [themeColor]="timeEntryisRunning ? 'error': 'success'"
      [style.width.px]="200"
      [disabled]="form.invalid"
      [loadingIndication]="timeEntryisRunning ? '/TimeEntry/stopTimeEntry' : '/TimeEntry/startTimeEntry'"
    >
        {{timeEntryisRunning ? 'Stop' : 'Start'}}
    </button>
    <span class="k-form-hint" *ngIf="timeEntryisRunning">
      Stoppen Sie Ihre Arbeitszeit
    </span>
    <span class="k-form-hint" *ngIf="!timeEntryisRunning">
      Starten Sie Ihre Arbeitszeit
    </span>
  </div>





  <kendo-formfield
    class="mbs"
    *ngIf="!timeEntryisRunning && form.get('assignment').value?.assignmentServices"
  >
    <kendo-label text="Dienstleistung"></kendo-label>
    <kendo-dropdownlist
        [data]="form.get('assignment').value?.assignmentServices"
        textField="remarks"
        valueField="id"
        [valuePrimitive]="false"
        formControlName="assignmentService"
        [defaultItem]="defaultItem"
    >
    </kendo-dropdownlist>
    <kendo-formhint>
      Wählen Sie eine Dienstleistung aus dem gewählten Auftrag
    </kendo-formhint>
  </kendo-formfield>

</form>